/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscalereadingfacesstrong4Inputs */



/**
* | output |
* | --- |
* | "You read emotions from facial expressions well and notice shifts in the other person's face." |
*
* @param {Eisubscalereadingfacesstrong4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscalereadingfacesstrong4 = /** @type {((inputs?: Eisubscalereadingfacesstrong4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscalereadingfacesstrong4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You read emotions from facial expressions well and notice shifts in the other person's face.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lees bien las emociones en la expresión facial y notas los cambios en el gesto de tu interlocutor.")
	return /** @type {LocalizedString} */ ("Ты хорошо считываешь эмоции по выражению лица и замечаешь изменения в мимике собеседника.")
});
export { eisubscalereadingfacesstrong4 as "eiSubscaleReadingFacesStrong" }